import { useEffect, useState } from 'react';

const MINUTE_MS = 60_000;

/**
 * 1분마다 갱신되는 현재 시각. 첫 렌더는 null — 하이드레이션은 서버 값으로 그린다.
 * 마운트 직후 바로 맞춘다(캐시된 HTML 의 서버 값은 몇 시간 전일 수 있다)
 */
export function useMinuteClock() {
  const [now, setNow] = useState<number | null>(null);

  useEffect(function tickEveryMinute() {
    setNow(Date.now());
    const id = setInterval(function updateNow() {
      setNow(Date.now());
    }, MINUTE_MS);
    return function stopTicking() {
      clearInterval(id);
    };
  }, []);

  return now;
}
